import { render, staticRenderFns } from "./ActionCards.vue?vue&type=template&id=0bf602a8&scoped=true&"
import script from "./ActionCards.vue?vue&type=script&lang=js&"
export * from "./ActionCards.vue?vue&type=script&lang=js&"
import style0 from "./ActionCards.vue?vue&type=style&index=0&id=0bf602a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf602a8",
  null
  
)

export default component.exports